import { default as GallectionDeviationManager } from './GallectionDeviationManager.connected';
export default GallectionDeviationManager;
